import React, { useEffect, useRef } from "react";

import PageHeading from "../../../../../components/PageHeading";

import { useIsNewNavigation } from "../../../../../api/hooks/defs/navigation";

//template
import InfoPageTemplate from "../../../../../pageTemplates/InfoPageTemplate";
import { CompanyReviewsNavigationLinks } from "../../constants";

const PAGE_TITLE = "Performance Graphs";

const PerformanceGraphsWrapper = () => {
	const containerRef = useRef(null);
	const isNewNav = useIsNewNavigation();

	/*
	 * The graph script populates the server-rendered `#reviews-dashboard` by id after mount, so move
	 * the live element in rather than a clone. Put it back and re-hide on unmount, or its shown state
	 * leaks into the next template-backed page.
	 */
	useEffect(() => {
		$("#tornado-template-content").show();
		$("#reviews-dashboard").show();
		$("#reviews-dashboard").css("visibility", "visible");
		if (containerRef.current) {
			$("#reviews-dashboard").appendTo(containerRef.current);
		}
		return () => {
			$("#reviews-dashboard").appendTo("#tornado-template-content");
			$("#tornado-template-content").hide();
		};
	}, []);

	const mainContent = <div ref={containerRef} />;

	return (
		<InfoPageTemplate
			pageTitle={PAGE_TITLE}
			pageHeading={isNewNav ? <PageHeading>{PAGE_TITLE}</PageHeading> : undefined}
			mainContent={mainContent}
			navigationLinks={CompanyReviewsNavigationLinks}
			activeNavigationLinkKey={"graphs"}
		/>
	);
};

export default PerformanceGraphsWrapper;
